<template>
    <el-container :class="{'floating-layer':true,'floating-layer-pc': !ismobile,'floating-layer-mobile': ismobile}" v-if="popShow" :style="{'width': diaWidth}">
         <div class="popDiaContent">
           <div class="head">
             <div class="headTitle"><span>{{$t(actionTitle)}}</span></div>
<!--             <div class="headDesc"><span>{{$t(actionDesc)}}</span></div>-->
             <div class="line"></div>
           </div>
           <div class="contentInput">
<!--             <div class="mobileTitle">{{$t('mobileTitle')}}</div>-->
             <div class="el-form-item__content height60">
               <div class="el-input input-bor">
                 <el-select style="width:35%;" v-model="selectTel" :placeholder="$t('Country')" filterable>
                   <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id">{{item.value}}</el-option>
                 </el-select>
                 <input style="width:62%;float: right" type="text" autocomplete="off" class="el-input__inner" ref="mobileinput" :placeholder="$t('mobileTitle')">
               </div>
               <div class="error" v-show="telErrorShow">
                 <span>{{$t(telErrorMsg)}}</span>
               </div>
             </div>
             <div class="el-form-item__content height60">
               <div class="el-input">
                 <input type="text" autocomplete="off" class="el-input__inner" style="width: 65%;margin-right: 3%" ref="codeinput" :placeholder="$t('inputMobileCode')">
                 <el-button class="send_mobile_code" style="width: 30%;padding: 0" @click="getMobileCode()">
                   <span v-show="this.expireTime === 0">{{$t('getMobileCode')}}</span>
                   <span v-show="this.expireTime > 0">{{expireTime}}S</span>
                 </el-button>
               </div>
               <div class="error" v-show="codeErrorShow">
                 <span>{{$t(codeErrorMsg)}}</span>
               </div>
             </div>
           </div>
           <div class="contentButton">
             <el-button class="CancelBtn" @click="close()" data-index="login-button">
               <span v-html="$t(actionLater)"></span>
             </el-button>
             <el-button class="SubmitBtn" @click="submitMobileForm()" data-index="login-button">
               <span v-html="$t(actionNow)"></span>
             </el-button>
           </div>
           <div class="MT10">
             <el-checkbox></el-checkbox>
             <span class="checkboxText">{{$t('IAgreeReceiveTextMessage')}}</span>
           </div>
           <div>
             <el-checkbox></el-checkbox>
             <span class="checkboxText">{{$t('IAgreeWith')}}
               <router-link :to="{name:'clause', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" target="_blank"> <span class="checkboxTextLink">{{$t('termsOfUse')}}</span> </router-link>
               {{$t('and')}}
               <router-link :to="{name:'policy', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" target="_blank"> <span class="checkboxTextLink">{{$t('privacyPolicy')}}</span> </router-link>
             </span>
           </div>
           <div class="line"></div>
           <div class="bindPopNotice">
             <div class="bindPopNoticeLine"><b>{{$t('bindPopNotice')}}:</b></div>
             <div class="bindPopNoticeLine">{{$t('bindPopNoticeLine1')}}</div>
             <div class="bindPopNoticeLine ML20">1. {{$t('bindPopNoticeLine2')}}</div>
             <div class="bindPopNoticeLine ML20">2. {{$t('bindPopNoticeLine3')}}</div>
           </div>
         </div>
         <!--遮罩层-->
        <div v-if="popShow" class="overlay"></div>
    </el-container>
</template>

<script>
import { authorizedLogin } from '@/request/login.js'
import publicMask from '@/components/public/publicMask'

export default {
  name: 'mobileLoginBindPop',
  props: ['popShow', 'actionSetup', 'telOptionsSetup', 'source', 'language', 'site', 'selectTelSetup', 'conver'],
  components: {
    authorizedLogin,
    publicMask
  },
  data () {
    return {
      ismobile: false,
      diaWidth: '500px',
      telOptions: [{id: 216, value: '美国 +1', telnum: 'US +1'}, {id: 42, value: '中国 +0086', telnum: 'CN +86'}],
      expireTime: 0,
      codeTimeExpireObj: false,
      telErrorShow: false,
      telErrorMsg: '',
      codeErrorShow: false,
      codeErrorMsg: '',
      actionLater: '',
      actionNow: '',
      actionTitle: '',
      actionDesc: '',
      selectTel: ''
    }
  },
  watch: {
    actionSetup: function (value) {
      if (value === 'login') {
        this.actionLater = 'registerLater'
        this.actionNow = 'registerNow'
        this.actionTitle = 'registerMobile'
        this.actionDesc = 'registerDesc'
      } else if (value === 'bind') {
        this.actionLater = 'BindLater'
        this.actionNow = 'BindNow'
        this.actionTitle = 'bindMobileTitle'
        this.actionDesc = 'bindMobileDesc'
      }
    },
    telOptionsSetup: function (value) {
      this.telOptions = value
    },
    selectTelSetup: function (value) {
      this.selectTel = value
    }
  },
  created () {},
  mounted () {
    if (document.documentElement.clientWidth < 1001) {
      this.ismobile = true
      this.diaWidth = '94%'
    } else {
      this.ismobile = false
      this.diaWidth = '500px'
    }
  },
  methods: {
    close () {
      // 点击完成 埋点记录
      this.clickPageAction('pop-bindMobile', this.actionLater, {}, {}, {})
      let data = {'bindRes': false}
      this.$emit('closepop', data)
    },
    getMobileCode () {
      let mobilePattern = /^\d+$/
      let mobile = this.$refs['mobileinput'].value
      if (mobile === '' || !mobilePattern.test(mobile)) {
        this.telErrorMsg = 'pleaseValidPhone'
        this.telErrorShow = true
        this.$refs['mobileinput'].focus()
        return false
      }
      if (this.expireTime > 0) {
        return false
      }
      let that = this
      this.telErrorMsg = ''
      this.telErrorShow = false
      let requestTime = parseInt(new Date().getTime())
      let time = parseInt(requestTime / 1000)
      let sessionid = this.common.sessionidGet(this)
      // 验证verify
      let token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      let dataJson = {
        'token': token,
        'mobile': mobile,
        'areaCode': this.selectTel,
        'time': time,
        'sessionid': sessionid,
        'operation': 'sendCode'
      }
      let data = this.common.encryptionData(dataJson, this)
      authorizedLogin(data).then(res => {
        // 点击完成 埋点记录
        this.clickPageAction('pop-bindMobile', 'getMobileCode', dataJson, dataJson, res)
        if (res.flag === '200') {
          that.expireTime = 59
          that.codeTimeExpireObj = setInterval(function () {
            if (that.expireTime === 0) {
              clearInterval(that.codeTimeExpireObj)
            } else {
              that.expireTime = that.expireTime - 1
            }
          }, 1000)
        } else if (res.flag === '601') {
          let data = {'bindRes': true}
          this.$emit('closepop', data)
        } else {
          this.telErrorShow = true
          this.telErrorMsg = res.msg
        }
      })
    },
    submitMobileForm () {
      let mobile = this.$refs['mobileinput'].value
      let code = this.$refs['codeinput'].value
      if (mobile === '') {
        this.telErrorMsg = 'pleaseValidPhone'
        this.telErrorShow = true
        this.$refs['mobileinput'].focus()
        return false
      }
      if (code === '') {
        this.codeErrorMsg = 'pleaseValidMobileCode'
        this.codeErrorShow = true
        this.$refs['codeinput'].focus()
        return false
      }
      this.telErrorShow = false
      this.telErrorMsg = ''
      this.codeErrorShow = false
      this.codeErrorMsg = ''
      let requestTime = parseInt(new Date().getTime())
      let time = parseInt(requestTime / 1000)
      let sessionid = this.common.sessionidGet(this)
      let searchHotelLocation = sessionStorage.getItem('search_hotel_location')
      // 验证verify
      let token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      let dataJson = {
        'token': token,
        'mobile': mobile,
        'areaCode': this.selectTel,
        'code': code,
        'source': this.source,
        'language': this.language,
        'site': this.site,
        'time': time,
        'sessionid': sessionid,
        'operation': 'Mobile',
        'searchHotelLocation': searchHotelLocation !== null ? searchHotelLocation : ''
      }
      let data = this.common.encryptionData(dataJson, this)
      authorizedLogin(data).then(res => {
        // 点击完成 埋点记录
        this.clickPageAction('pop-bindMobile', this.actionNow, dataJson, dataJson, res)
        let data = {'bindRes': true}
        if (res.flag === '200' || res.flag === '201') {
          localStorage.setItem('token', res.data.token)
          this.$emit('closepop', data)
        } else if (res.flag === '601') {
          this.$emit('closepop', data)
        } else {
          this.codeErrorMsg = res.msg
          this.codeErrorShow = true
        }
      })
    }
  },
  computed: {}
}
</script>

<style scoped>
.floating-layer {
  width: 500px;
  background-color: #ffffff;
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  line-height: normal;
  position: fixed;
  display: flex;
  justify-content: flex-end;
  z-index: 1999;
}

.floating-layer-mobile {
  right: 3vw !important;
  height: 570px;
  top: calc((100vh - 570px) / 2) !important;
}

.floating-layer-pc {
  right: calc((100vw - 500px) / 2) !important;
  height: 520px;
  top: calc((100vh - 520px) / 2) !important;
}

.popDiaContent {
  width: 100%;
  padding: 20px 30px;
  border-radius: 10px;
  border: 1px solid #e1e2ef;
  background-color: #ffffff;
  box-sizing: border-box;
  box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.1);
  z-index: 2002
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000; /* 遮罩层的 z-index */
}

.head{
  width: 100%;
  background-color: rgba(255, 255, 255, 0);
}

.headTitle {
  height: 30px;
  line-height: 30px;
  font-size: 20px;
  font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold', 'PingFang SC', sans-serif;
  color: #4f4c4c;
  text-align: center;
}

.headDesc {
  line-height: 19px;
  font-size: 14px;
  color: #F56C6C;
  text-align: left;
}

.line {
  width: 100%;
  height: 1px;
  margin-top: 10px;
  margin-bottom: 10px;
  background-image: url(/static/img/login/line.svg);
  background-repeat: repeat-x;
  background-position: 50%;
}

.MT10 {
  margin-top: 10px;
}

.checkboxText {
  line-height: 20px;
  font-size: 14px;
  color: #4f4c4c;
}

.checkboxText a {
  text-decoration : none;
}
.checkboxTextLink {
  color: rgb(83, 146, 249);
  font-weight: 650;
  cursor: pointer;
}

.contentInput {
  width: 100%;
  /*height: 155px;*/
  background-color: #ffffff;
  font-size: 14px;
}

.contentInput .mobileTitle {
  height: 19px;
  line-height: 19px;
  color: #606266;
  text-align: left;
  margin: 6px 0 6px 0;
}

.height60 {
  min-height: 65px;
}

.input-bor {
  height: 40px;
}

.input-bor /deep/ .el-select .el-input.is-focus .el-input__inner,.input-bor /deep/ .el-select .el-input__inner:focus{
  border-color:rgb(252, 210, 5, 1);
  box-shadow: 0px 0px 8px rgb(252 210 5);
}

.contentInput{ font-size:13px;}
.contentInput input:hover{ border-color:rgb(79, 76, 76, 1);}
.contentInput input:focus{ border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
.contentInput .error{
  color:#E12D2D;
  font-size:12px;
  text-align: left;
  min-height: 16px;
  line-height: 16px;
  margin: 2px 0 1px 8px;
}

.send_mobile_code {
  text-align: center;
  width: 100%;
  height: 40px;
  font-size:14px;
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  background-color: #ffffff;
  box-sizing: border-box;
  border: 1px solid rgba(79, 76, 76, 1);
  border-radius: 4px;
  -moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);
  color: #4f4c4c;
}

.contentButton {
  display: flex;
  justify-content: space-between;
  /*margin: 38px 0 50px 0;*/
}

.CancelBtn {
  text-align: center;
  width: 48%;
  height: 44px;
  font-size:16px;
  font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold', 'PingFang SC', sans-serif;
  background-color: #ffffff;
  box-sizing: border-box;
  border: 1px solid #e1e2ef;
  border-radius: 4px;
  -moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);
  color: #4f4c4c;
}
.CancelBtn:hover {
  background-color: #4f4c4c;
  box-sizing: border-box;
  color: #fcd205;
}
.CancelBtn:active {
  background-color: #4f4c4c;
  box-sizing: border-box;
  color: #fcd205;
}

.SubmitBtn {
  width: 48%;
  height: 44px;
  font-size:16px;
  font-family: 'PingFangSC-Semibold', 'PingFang SC Semibold', 'PingFang SC', sans-serif;
  background-color: rgba(79, 76, 76, 1);
  box-sizing: border-box;
  border: 1px solid rgba(79, 76, 76, 1);
  border-radius: 4px;
  -moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.34901960784313724);
  color: #FFFFFF;
}
.SubmitBtn:hover {
  background-color: #fcd205;
  box-sizing: border-box;
  color: #4f4c4c;
}
.SubmitBtn:active {
  background-color: #fcd205;
  box-sizing: border-box;
  color: #4f4c4c;
}
.SubmitBtn:checked {
  background-color: #fcd205;
  box-sizing: border-box;
  color: #4f4c4c;
}

.send_mobile_code:hover, .send_mobile_code{background-color: rgba(79, 76, 76, 1) !important; color:#ffffff !important;}

.bindPopNotice {
  width: 100%;
}

.bindPopNoticeLine {
  line-height: 20px;
  font-size: 14px;
  color: #4f4c4c;
}

.ML20 {
  margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/login/module/mobileLoginBindPop.vue